import qrLogo from '../../../assets/images/favicon/favicon.svg?inline';
import heroBg from '../../../assets/images/deeplink/mobile-hero-bg.svg';
import desktopBannerBg from '../../../assets/images/deeplink/desktop-banner-bg.png';
import tokeLogoWhite from '../../../assets/images/deeplink/toke-logo-white.svg';
import tokeLogo from '../../../assets/images/deeplink/toke-logo.svg';
import popularLogo from '../../../assets/images/deeplink/popular-logo.svg';
import qikLogo from '../../../assets/images/deeplink/qik-logo.svg';
import lockIcon from '../../../assets/images/deeplink/lock-icon.svg';
import flecha from '../../../assets/images/deeplink/flecha.png';
import checkCoin from '../../../assets/images/deeplink/toke_check_coin.svg';
import copyIcon from '../../../assets/images/deeplink/copy_icon.svg';
import checkIcon from '../../../assets/images/deeplink/check_icon.svg';


export const deeplinkData = {

    header: {
        title: '¿Desde dónde quieres pagar?',
        subtitle: 'Serás enviado a la aplicación que escojas.'
    },

    desktop: {
        title: '¡Hola!',
        subtitle: 'Continúa este pago desde tu teléfono celular',
        helperText: 'Escanea este código QR con tu celular',

        bannerBackground: desktopBannerBg,
        bannerLogo: tokeLogoWhite,

        qrLogo,

        copyLabel: 'Copiar enlace',
        copyIcon: copyIcon,
        checkIcon: checkIcon,

        topDecal: checkCoin,
        bottomDecal: flecha
    },

    mobile: {
        secureLabel: 'Pago seguro por Toke.',
        secureIcon: lockIcon,

        heroBackground: heroBg,

        heroLogo: tokeLogoWhite,
        heroCoin: flecha,

        badgeLabel: 'Paga en un'
    },


    error: {
        title: 'Enlace inválido',
        body: 'El enlace que estás usando no tiene la información necesaria para completar el pago.'
    },


    channels: [
        {
            id: 'toke',
            label: 'Toke',
            logo: tokeLogo,
            logoClass: 'deeplink-mobile__button-logo'
        },
        {
            id: 'popular',
            label: 'Popular',
            logo: popularLogo,
            logoClass: 'deeplink-mobile__button-logo'
        },
        {
            id: 'qik',
            label: 'Qik',
            logo: qikLogo,
            logoClass: 'deeplink-mobile__button-logo'
        }
    ],


    config: {

        smtype: '3',

        // Tipos de deeplink soportados 
        supportedDlTypes: [
            'cobroQR',
            'alias'
        ],

        // Parámetros de consulta requeridos
        requiredParams: [
            '_dl',     // Tipo de deeplink
            '_p'      // Número de teléfono o alias a pagar
        ],


        channels: {

            toke: {
                baseUrl: 'https://toke.sng.link/Eaumb',
                path: 'dfalq',

                mappings: {
                    cobroQR: 'cobroQR',
                    alias: 'alias'
                }
            },

            popular: {
                baseUrl: 'https://popular.sng.link',
                path: 'cfp13',

                mappings: {
                    cobroQR: 'tokeQR',
                    alias: 'aliasToke'
                }
            },

            qik: {
                baseUrl: 'https://qik.sng.link/Efcxh',
                path: 'weixq',

                mappings: {
                    cobroQR: 'qik.app.toke.qr',
                    alias: 'qik.app.toke.alias'
                }
            }
        }
    }
};